import { createSlice } from '@reduxjs/toolkit';
import { Company } from '@src/types/company';
import { Project } from '@src/types/project';
import getUserList from './userListThunk';

export const EXPORT_LIMIT = 100;

export type SearchByType = 'name' | 'email' | 'mobileNumber' | 'role';

export interface UsersState {
  id?: number;
  openId?: string;
  channelTalkUserId?: string;
  updatedAt?: string;
  createdAt?: string;
  email?: string;
  passwdUpdatedAt?: string;
  mobileNumber?: string;
  name?: string;
  role?: string;
  projects?: Project[];
  managers?: { id: number; company: Company }[];
}

export interface UsersMetaDto {
  totalItems?: number;
  totalPages?: number;
  currentPage?: number;
  itemsPerPage?: number;
}

export interface UserListParams {
  page?: number;
  limit?: number;
  sortBy?: string[];
  searchBy?: SearchByType;
  search?: string;
  filter?: { 'managers.company.id'?: string; role?: string };
  [key: string]: any;
}

interface InitialState {
  loading: boolean;
  users: UsersState[];
  meta: UsersMetaDto;
  params: UserListParams;
}

const initialState: InitialState = {
  loading: false,
  users: [],
  meta: {
    totalItems: 1,
    totalPages: 1,
  },
  params: {
    page: 1,
    limit: 20,
    sortBy: [''],
    searchBy: 'name',
    search: '',
    filter: {},
  },
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    onChangePageNum(state, { payload }) {
      state.params.page = payload + 1;
    },
    onChangeLimit(state, { payload }) {
      state.params.limit = payload;
    },
    onChangeSearchBy(state, { payload }) {
      state.params.searchBy = payload;
    },
    onChangeSearch(state, { payload }) {
      state.params.search = payload;
    },
    onChangeRole(state, { payload }) {
      const { id, role } = payload;

      const selectedUser = state.users.findIndex(
        (element) => element.id === id
      );

      state.users[selectedUser].role = role;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUserList.fulfilled, (state, { payload }) => {
      state.loading = false;

      /* 내보내기 요청일 경우 저장하지 않음 */
      if (payload.meta.itemsPerPage === EXPORT_LIMIT) return;

      state.users = payload.data;
      state.meta = payload.meta;
    });
    builder.addCase(getUserList.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const {
  onChangePageNum,
  onChangeLimit,
  onChangeSearch,
  onChangeSearchBy,
  onChangeRole,
} = usersSlice.actions;

export default usersSlice.reducer;
